export const PROMO_CODE = 'PROMO_CODE'
export const DEAL_CODE = 'DEAL_CODE'

export const SKIP_DEFAULT = 0
export const LIMIT_DEFAULT = 10

export const AUTH_SESSION = 'AUTH_SESSION'

export const CAN_PURCHASE_ADDONS_THRESHOLD_DAYS = 14

export const EDIT_REQUEST_DEADLINE_DAYS = 5
